/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `EXW` - Ex Works
* `FCA` - Free Carrier
* `FAS` - Free Alongside Ship
* `FOB` - Free On Board
* `CFR` - Cost and Freight
* `CIF` - Cost, Insurance and Freight
* `CPT` - Carriage Paid To
* `CIP` - Carriage and Insurance Paid To
* `DAP` - Delivered At Place
* `DPU` - Delivered at Place Unloaded
* `DDP` - Delivered Duty Paid
 */
export type IncotermEnum = typeof IncotermEnum[keyof typeof IncotermEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncotermEnum = {
  EXW: 'EXW',
  FCA: 'FCA',
  FAS: 'FAS',
  FOB: 'FOB',
  CFR: 'CFR',
  CIF: 'CIF',
  CPT: 'CPT',
  CIP: 'CIP',
  DAP: 'DAP',
  DPU: 'DPU',
  DDP: 'DDP',
} as const;
